import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './components/Home';
import Services from './components/Services';
import Products from './components/Products';
import Projects from './components/Projects';
import About from './components/About';
import Contact from './components/Contact';
import GridSync from './components/GridSync';

import Landing from './components/Landing';
import LandingJustin from './components/LandingJustin';

import './App.css';

function AppWrapper() {
  const location = useLocation();

  // Pages that should NOT show Navbar & Footer
  const noLayoutPages = ['/landing', '/landing-justin'];
  const hideLayout = noLayoutPages.includes(location.pathname);

  return (
    <>
      {!hideLayout && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gridsync" element={<GridSync />} />

        {/* LANDING PAGES */}
        <Route path="/landing" element={<Landing />} />
        <Route path="/landing-justin" element={<LandingJustin />} />
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
